import { useMemo } from 'react';
import { Icon, Space, Text } from 'ui';

type P = {
  type?: 'daily' | 'monthly' | 'weekly';
};

const Repeats = ({ type }: P) => {
  const text = useMemo(() => {
    switch (type) {
      case 'daily':
        return 'Repeats daily';
      case 'monthly':
        return 'Repeats monthly';
      case undefined:
        return 'No repeat';
      case 'weekly':
        return 'Repeats weekly';
    }
  }, [type]);

  if (!type) {
    return null;
  }

  return (
    <Space size="xxs">
      <Icon icon="refresh-4-line" size="extra-small" /> <Text>{text}</Text>
    </Space>
  );
};

export default Repeats;
